import React from 'react'
import Header from '../Header'
import Abanner from '../admissions/Abanner'
import Footer from '../Footer'
import Content from '../admissions/Content'
import Expertsolution from '../admissions/Expertsolution'

const Admission1 = () => {
  return (
    <div>
      <Header/>
      <Abanner/>
      <Content/>
      <Expertsolution/>
      <Footer/>
    </div>
  )
}

export default Admission1